import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isSensitiveTimeWindow(timestampMs: number): boolean {
  const date = new Date(timestampMs);
  const hour = date.getHours();
  return hour >= 23 || hour < 4;
}
